exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-found__label {\n    /*color: #333;*/\n    color: #151515;\n    text-align: center;\n    display: inline-block;\n    width: 100%;\n    margin: 3em 0;\n    -webkit-text-shadow: 1px 1px 1px #fff;\n    -moz-text-shadow: 1px 1px 1px #fff;\n    -ms-text-shadow: 1px 1px 1px #fff;\n    -o-text-shadow: 1px 1px 1px #fff;\n    text-shadow: 1px 1px 1px #fff;\n    font-weight: bold;\n    font-size: 4em;\n}\n.not-found__label span {\n    color: #8ac440;\n    -webkit-text-shadow: none;\n    -moz-text-shadow: none;\n    -ms-text-shadow: none;\n    -o-text-shadow: none;\n    text-shadow: none;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/defaults/not-found/not-found.component.css
// module id = ../../../../../angular/app/components/defaults/not-found/not-found.component.css
// module chunks = 1